import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCategories } from '../../store/slices/productSlice';
import { getProductsApi } from '../../api/productApi';
import imgUrl from '../../utils/imgUrl';
import useIsMobile from '../../hooks/useIsMobile';

const imgSrc = imgUrl;

const TESTIMONIALS = [
  { name:'Soumya Roy',       loc:'London, UK',    stars:5, text:'Finally a Bengali streetwear brand that gets it. Wore the Howrah Bridge tee to a South Asian cultural evening and everyone asked where I got it from.' },
  { name:'Pritha Banerjee',  loc:'Kolkata, WB',   stars:5, text:"The fabric quality is insane for the price. Soft, breathable, and the prints haven’t faded after 10+ washes. Ordered 3 more." },
  { name:'Ayan Mukherjee',   loc:'Mumbai, MH',    stars:5, text:'Gifted my baba the Phuchka Club tee for his birthday. He literally cried. Nostalgia is real and Bhadralok captures it perfectly.' },
];

const FEATURES = [
  { icon:'🚚', title:'Free Shipping',  sub:'Orders above ₹699' },
  { icon:'✓',  title:'100% Cotton',    sub:'Breathable & premium' },
  { icon:'🏭', title:'Made in Bengal', sub:'Local craft, global style' },
  { icon:'↩',  title:'Easy Returns',   sub:'7-day hassle-free' },
];

function ProductCard({ p }) {
  const disc = p.compare_price ? Math.round((1 - p.price / p.compare_price) * 100) : 0;
  return (
    <Link to={`/products/${p.slug}`} style={{ textDecoration:'none', color:'inherit' }}>
      <div className="product-card">
        <div className="product-img">
          {disc > 0 && <span className="p-tag p-tag-red">{disc}% OFF</span>}
          <div className="product-img-inner">
            {imgSrc(p.image)
              ? <img src={imgSrc(p.image)} alt={p.name} style={{ width:'100%', height:'100%', objectFit:'cover' }} />
              : <span style={{ fontSize:'64px' }}>👕</span>}
          </div>
        </div>
        <p className="p-name">{p.name}</p>
        <p className="p-price">
          ₹{Number(p.price).toLocaleString('en-IN')}
          {p.compare_price && <span className="p-price-orig">₹{Number(p.compare_price).toLocaleString('en-IN')}</span>}
        </p>
      </div>
    </Link>
  );
}

export default function Home() {
  const dispatch = useDispatch();
  const { categories } = useSelector((s) => s.product);
  const isMobile = useIsMobile();

  const [bestSellers, setBestSellers] = useState([]);
  const [newArrivals, setNewArrivals] = useState([]);
  const [loadingBS,   setLoadingBS]   = useState(true);
  const [loadingNA,   setLoadingNA]   = useState(true);
  const [email,       setEmail]       = useState('');
  const [subDone,     setSubDone]     = useState(false);

  useEffect(() => {
    dispatch(fetchCategories());
    getProductsApi({ sort:'newest', limit:4 })
      .then((r) => setNewArrivals(r.data.products || []))
      .finally(() => setLoadingNA(false));
    getProductsApi({ limit:4 })
      .then((r) => setBestSellers(r.data.products || []))
      .finally(() => setLoadingBS(false));
  }, [dispatch]);

  return (
    <div className="page-top">

      {/* ── Announcement Bar ── */}
      <div className="ann-bar">
        🚚 Free shipping on orders above <span>₹999</span> &nbsp;|&nbsp; Use code <span>ADDA10</span> for 10% off
      </div>

      {/* ══════════════════════════════════════
          HERO
      ══════════════════════════════════════ */}
      <div style={{ ...S.hero, gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', minHeight: isMobile ? 'auto' : '90vh' }}>
        <div style={{ ...S.heroLeft, padding: isMobile ? '40px 20px' : '72px 56px' }}>
          <div style={S.heroTag}>
            <span style={S.heroPulse} />
            🟠 NEW COLLECTION — MONSOON 2026
          </div>
          <h1 style={S.heroHeadline}>
            WEAR YOUR<br />
            <span style={{ color:'var(--red)' }}>BENGALI</span><br />
            SOUL
          </h1>
          <p style={S.heroScript}>Cha, Adda, Identity</p>
          <p style={S.heroDesc}>
            Premium Bengali streetwear rooted in culture, crafted for the modern adda.
            Because where you're from defines what you wear.
          </p>
          <div style={S.heroCtas}>
            <Link to="/products" className="btn-primary">Shop Now →</Link>
            <Link to="/about" className="btn-outline">Our Story</Link>
          </div>
        </div>
        {!isMobile && (
          <div style={S.heroRight}>
            <div style={S.heroBgText}>BHADRALOK</div>
            <div style={S.heroCard}>
              <span style={S.heroCardTag}>BESTSELLER</span>
              <div style={{ height:'220px', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'90px', background:'var(--light)' }}>👕</div>
              <div style={S.heroCardInfo}>
                <p style={{ fontFamily:'var(--font-display)', fontSize:'18px', letterSpacing:'1px', margin:'0 0 4px' }}>Adda Kurta</p>
                <p style={{ fontSize:'19px', fontWeight:700, color:'var(--red)', margin:0 }}>
                  ₹899 <span style={{ fontSize:'12px', color:'#aaa', textDecoration:'line-through', fontWeight:400 }}>₹1299</span>
                </p>
              </div>
            </div>
            <div style={S.heroFloat}>
              <span style={{ ...S.ftag, background:'var(--red)',   color:'#fff',           transform:'rotate(1.5deg)' }}>HANDCRAFTED</span>
              <span style={{ ...S.ftag, background:'var(--green)', color:'#fff',           transform:'rotate(-1deg)' }}>BENGALI</span>
              <span style={{ ...S.ftag, background:'var(--gold)',  color:'var(--black)',   transform:'rotate(1deg)' }}>PREMIUM</span>
            </div>
          </div>
        )}
      </div>

      {/* ══════════════════════════════════════
          SHOP BY COLLECTION
      ══════════════════════════════════════ */}
      <div className="section">
        <div className="sec-header">
          <div>
            <p className="sec-label">Browse by Vibe</p>
            <h2 className="sec-title">SHOP THE <span style={{ color:'var(--green)' }}>COLLECTION</span></h2>
          </div>
          <Link to="/products" className="view-all">View All →</Link>
        </div>
        <div style={{ ...S.catGrid, gridTemplateColumns: isMobile ? 'repeat(2,1fr)' : 'repeat(4,1fr)' }}>
          {(categories.length > 0 ? categories : [{ id:'1',name:'Tees' },{ id:'2',name:'Kurtas' },{ id:'3',name:'Accessories' },{ id:'4',name:'Bottoms' }]).slice(0,4).map((cat, i) => {
            const colors = ['var(--red)','var(--green)','var(--gold)','var(--charcoal)'];
            const icons  = ['👕','🥻','🎒','👖'];
            return (
              <Link key={cat.id} to={`/products?category=${cat.id}`}
                style={{ ...S.catCard, borderTop:`3px solid ${colors[i % 4]}` }}>
                <div style={S.catIcon}>{icons[i % 4]}</div>
                <p style={S.catName}>{cat.name}</p>
                <p style={S.catSub}>Explore collection →</p>
              </Link>
            );
          })}
        </div>
      </div>

      {/* ══════════════════════════════════════
          DUAL BANNER
      ══════════════════════════════════════ */}
      <div style={{ ...S.dualBanner, gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr' }}>
        {/* Banner 1 — Howrah / Red */}
        <div style={{ ...S.bannerSlot, background:'var(--red)', position:'relative', overflow:'hidden', padding: isMobile ? '48px 24px' : '72px 64px' }}>
          <div style={{ ...S.bannerBg, color:'rgba(255,255,255,.06)' }}>হাওড়া</div>
          <div style={{ position:'relative', zIndex:2 }}>
            <p style={S.bannerKicker}>Limited Edition</p>
            <h2 style={S.bannerTitle}>MONSOON<br />COLLECTION</h2>
            <p style={S.bannerDesc}>Hand-block printed on pure cotton. Made for the rains of Kolkata.</p>
            <Link to="/products" style={{ ...S.bannerBtn, background:'#fff', color:'var(--red)', border:'2px solid #fff' }}>Shop Now →</Link>
          </div>
        </div>
        {/* Banner 2 — Adda / Black */}
        <div style={{ ...S.bannerSlot, background:'var(--black)', position:'relative', overflow:'hidden', padding: isMobile ? '48px 24px' : '72px 64px' }}>
          <div style={{ ...S.bannerBg, color:'rgba(255,255,255,.04)' }}>আড্ডা</div>
          <div style={{ position:'relative', zIndex:2 }}>
            <p style={S.bannerKicker}>Midnight Drop</p>
            <h2 style={S.bannerTitle}>ADDA NIGHT<br />EDITION</h2>
            <p style={S.bannerDesc}>For the night owls. For the para adda. For the ones who stay up talking.</p>
            <Link to="/products" style={S.bannerBtn}>Explore →</Link>
          </div>
        </div>
      </div>

      {/* ══════════════════════════════════════
          BEST SELLERS
      ══════════════════════════════════════ */}
      <div className="section">
        <div className="sec-header">
          <div>
            <p className="sec-label">Community Favourites</p>
            <h2 className="sec-title">BEST <span style={{ color:'var(--red)' }}>SELLERS</span></h2>
          </div>
          <Link to="/products" className="view-all">View All →</Link>
        </div>
        {loadingBS ? (
          <div style={{ ...S.productsGrid, gridTemplateColumns: isMobile ? 'repeat(2,1fr)' : 'repeat(4,1fr)' }}>
            {[1,2,3,4].map((i) => <div key={i} style={{ ...S.skelCard, gridColumn: isMobile && i > 2 ? 'span 1' : undefined }} />)}
          </div>
        ) : (
          <div style={{ ...S.productsGrid, gridTemplateColumns: isMobile ? 'repeat(2,1fr)' : 'repeat(4,1fr)' }}>
            {bestSellers.map((p) => <ProductCard key={p.id} p={p} />)}
          </div>
        )}
      </div>

      {/* ══════════════════════════════════════
          FEATURES STRIP
      ══════════════════════════════════════ */}
      <div style={{ ...S.featuresStrip, gridTemplateColumns: isMobile ? 'repeat(2,1fr)' : 'repeat(4,1fr)' }}>
        {FEATURES.map((f) => (
          <div key={f.title} style={S.featureItem}>
            <div style={S.featureIcon}>{f.icon}</div>
            <div>
              <p style={S.featureTitle}>{f.title}</p>
              <p style={S.featureSub}>{f.sub}</p>
            </div>
          </div>
        ))}
      </div>

      {/* ══════════════════════════════════════
          STORY SECTION
      ══════════════════════════════════════ */}
      <div style={{ ...S.story, gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr' }}>
        <div style={{ ...S.storyLeft, padding: isMobile ? '48px 20px' : '80px 56px' }}>
          <p style={S.storyKicker}>Our Story</p>
          <h2 style={S.storyTitle}>BORN IN THE<br />ADDAS OF KOLKATA</h2>
          <p style={S.storyBody}>
            Bhadralok started as a conversation over cha at a parar dokan. Every piece is rooted in Kolkata's streets,
            its sounds, its stories — the bhadralok spirit of intellectual wit, warmth, and unmistakable style.
          </p>
          <Link to="/about" style={S.storyBtn}>Read Our Story →</Link>
          <div style={S.storyStats}>
            {[['50K+','Happy Customers'],['200+','Unique Designs'],['4.9★','Avg. Rating']].map(([val, lbl]) => (
              <div key={lbl} style={S.statItem}>
                <p style={S.statVal}>{val}</p>
                <p style={S.statLbl}>{lbl}</p>
              </div>
            ))}
          </div>
        </div>
        {!isMobile && (
          <div style={S.storyRight}>
            <div style={S.storyEmblem}>
              <div style={{ fontFamily:'var(--font-display)', fontSize:'42px', letterSpacing:'4px', color:'var(--gold)', textAlign:'center', lineHeight:1 }}>
                BHADRA<br />LOK
              </div>
              <div style={{ width:'60px', height:'1px', background:'var(--gold)', margin:'14px auto' }} />
              <p style={{ fontFamily:'var(--font-script)', fontSize:'18px', color:'rgba(255,255,255,.5)', textAlign:'center' }}>Cha · Adda · Identity</p>
            </div>
            <div style={S.storyBgText}>বাংলা</div>
          </div>
        )}
      </div>

      {/* ══════════════════════════════════════
          NEW ARRIVALS
      ══════════════════════════════════════ */}
      <div className="section" style={{ background:'var(--light)' }}>
        <div className="sec-header">
          <div>
            <p className="sec-label">Just Dropped</p>
            <h2 className="sec-title">NEW <span style={{ color:'var(--red)' }}>ARRIVALS</span></h2>
          </div>
          <Link to="/products" className="view-all">View All →</Link>
        </div>
        {loadingNA ? (
          <div style={{ ...S.productsGrid, gridTemplateColumns: isMobile ? 'repeat(2,1fr)' : 'repeat(4,1fr)' }}>
            {[1,2,3,4].map((i) => <div key={i} style={{ ...S.skelCard, gridColumn: isMobile && i > 2 ? 'span 1' : undefined }} />)}
          </div>
        ) : (
          <div style={{ ...S.productsGrid, gridTemplateColumns: isMobile ? 'repeat(2,1fr)' : 'repeat(4,1fr)' }}>
            {newArrivals.map((p) => <ProductCard key={p.id} p={p} />)}
          </div>
        )}
      </div>

      {/* ══════════════════════════════════════
          TESTIMONIALS
      ══════════════════════════════════════ */}
      <div className="section">
        <div className="sec-header">
          <div>
            <p className="sec-label">Community Love</p>
            <h2 className="sec-title">WHAT THE <span style={{ color:'var(--gold)' }}>ADDA</span> SAYS</h2>
          </div>
        </div>
        <div style={{ ...S.testGrid, gridTemplateColumns: isMobile ? '1fr' : 'repeat(3,1fr)' }}>
          {TESTIMONIALS.map((t) => (
            <div key={t.name} style={S.testCard}>
              <div style={S.testStars}>{'★'.repeat(t.stars)}</div>
              <p style={S.testText}>"{t.text}"</p>
              <div style={S.testAuthor}>
                <div style={S.testAvatar}>{t.name[0]}</div>
                <div>
                  <p style={{ fontWeight:700, fontSize:'13px', margin:0 }}>{t.name}</p>
                  <p style={{ fontSize:'11px', color:'#888', margin:0 }}>{t.loc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ══════════════════════════════════════
          NEWSLETTER
      ══════════════════════════════════════ */}
      <div style={{ ...S.newsletter, gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', padding: isMobile ? '48px 20px' : '72px 64px', gap: isMobile ? '24px' : '40px' }}>
        <div style={S.nlLeft}>
          <p style={{ fontSize:'10px', fontWeight:700, letterSpacing:'3px', textTransform:'uppercase', color:'var(--gold)', marginBottom:'10px' }}>
            Join the Adda
          </p>
          <h2 style={{ fontFamily:'var(--font-display)', fontSize:'clamp(28px,3.5vw,46px)', letterSpacing:'2px', color:'#fff', lineHeight:1, marginBottom:'10px' }}>
            GET EARLY ACCESS
          </h2>
          <p style={{ fontSize:'14px', color:'rgba(255,255,255,.5)', lineHeight:1.7, maxWidth:'380px' }}>
            Be the first to know about new drops, exclusive offers, and stories from the adda.
          </p>
        </div>
        <div style={S.nlRight}>
          {subDone ? (
            <p style={{ color:'var(--gold)', fontFamily:'var(--font-display)', fontSize:'22px', letterSpacing:'2px' }}>
              ✓ WELCOME TO THE ADDA!
            </p>
          ) : (
            <form onSubmit={(e) => { e.preventDefault(); if (email) setSubDone(true); }}
              style={{ display:'flex', gap:'0', maxWidth:'460px', width:'100%' }}>
              <input
                type="email" required
                placeholder="your@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={S.nlInput}
              />
              <button type="submit" style={S.nlBtn}>Subscribe</button>
            </form>
          )}
          <p style={{ fontSize:'11px', color:'rgba(255,255,255,.25)', marginTop:'10px' }}>
            No spam. Unsubscribe any time.
          </p>
        </div>
      </div>

      <style>{`
        @keyframes pulse { 0%,100%{opacity:1;transform:scale(1)} 50%{opacity:.5;transform:scale(1.4)} }
      `}</style>
    </div>
  );
}

const S = {
  /* ── Hero ── */
  hero:         { background:'var(--black)', display:'grid', gridTemplateColumns:'1fr 1fr', minHeight:'90vh', borderBottom:'4px solid var(--gold)' },
  heroLeft:     { padding:'72px 56px', display:'flex', flexDirection:'column', justifyContent:'center' },
  heroTag:      { display:'inline-flex', alignItems:'center', gap:'8px', background:'rgba(200,149,42,.1)', border:'1px solid var(--gold)', color:'var(--gold)', padding:'6px 16px', fontSize:'11px', fontWeight:600, letterSpacing:'2px', textTransform:'uppercase', width:'fit-content', marginBottom:'26px' },
  heroPulse:    { width:'6px', height:'6px', borderRadius:'50%', background:'var(--gold)', display:'inline-block', animation:'pulse 2s infinite', flexShrink:0 },
  heroHeadline: { fontFamily:'var(--font-display)', fontSize:'clamp(56px,7vw,100px)', lineHeight:.92, color:'#fff', letterSpacing:'2px', marginBottom:'22px' },
  heroScript:   { fontFamily:'var(--font-script)', fontSize:'24px', color:'rgba(255,255,255,.55)', marginBottom:'14px' },
  heroDesc:     { color:'rgba(255,255,255,.45)', fontSize:'15px', lineHeight:1.7, maxWidth:'380px', marginBottom:'42px' },
  heroCtas:     { display:'flex', gap:'13px', flexWrap:'wrap' },
  heroRight:    { position:'relative', display:'flex', alignItems:'center', justifyContent:'center', overflow:'hidden', background:'var(--charcoal)' },
  heroBgText:   { position:'absolute', fontFamily:'var(--font-display)', fontSize:'200px', color:'rgba(255,255,255,.03)', letterSpacing:'-10px', whiteSpace:'nowrap', userSelect:'none', top:'50%', left:'50%', transform:'translate(-50%,-50%) rotate(-10deg)' },
  heroCard:     { background:'var(--offwhite)', width:'280px', position:'relative', zIndex:2, borderTop:'4px solid var(--red)', overflow:'hidden' },
  heroCardTag:  { position:'absolute', top:'-12px', left:'18px', background:'var(--red)', color:'#fff', fontSize:'9px', fontWeight:700, letterSpacing:'3px', padding:'4px 12px', zIndex:3 },
  heroCardInfo: { padding:'14px 22px 20px', borderTop:'1px solid var(--border)' },
  heroFloat:    { position:'absolute', top:'40px', right:'20px', display:'flex', flexDirection:'column', gap:'7px', zIndex:3 },
  ftag:         { fontSize:'10px', fontWeight:700, letterSpacing:'1.5px', padding:'5px 12px', textTransform:'uppercase', display:'block' },

  /* ── Categories ── */
  catGrid:      { display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:'16px' },
  catCard:      { background:'#fff', padding:'28px 20px', cursor:'pointer', transition:'box-shadow .2s', textDecoration:'none', color:'var(--black)', display:'block' },
  catIcon:      { fontSize:'36px', marginBottom:'12px' },
  catName:      { fontFamily:'var(--font-display)', fontSize:'20px', letterSpacing:'1px', marginBottom:'4px', margin:'0 0 4px' },
  catSub:       { fontSize:'12px', color:'#888', margin:0 },

  /* ── Dual Banner ── */
  dualBanner:   { display:'grid', gridTemplateColumns:'1fr 1fr' },
  bannerSlot:   { padding:'72px 64px', minHeight:'340px', display:'flex', alignItems:'center' },
  bannerBg:     { position:'absolute', fontFamily:'var(--font-display)', fontSize:'180px', lineHeight:1, userSelect:'none', bottom:'-20px', right:'20px', letterSpacing:'-5px' },
  bannerKicker: { fontSize:'10px', fontWeight:700, letterSpacing:'3px', textTransform:'uppercase', color:'rgba(255,255,255,.6)', marginBottom:'10px', margin:'0 0 10px' },
  bannerTitle:  { fontFamily:'var(--font-display)', fontSize:'clamp(32px,4vw,54px)', lineHeight:.95, letterSpacing:'2px', color:'#fff', marginBottom:'14px', margin:'0 0 14px' },
  bannerDesc:   { fontSize:'14px', color:'rgba(255,255,255,.6)', marginBottom:'24px', lineHeight:1.7, maxWidth:'340px', margin:'0 0 24px' },
  bannerBtn:    { display:'inline-block', background:'transparent', color:'#fff', border:'2px solid rgba(255,255,255,.4)', padding:'12px 28px', fontSize:'12px', fontWeight:700, letterSpacing:'2px', textTransform:'uppercase', textDecoration:'none', transition:'all .2s' },

  /* ── Products ── */
  productsGrid: { display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:'22px' },
  skelCard:     { height:'320px', background:'linear-gradient(90deg,#f0f0f0 25%,#e8e8e8 50%,#f0f0f0 75%)', backgroundSize:'200% 100%', animation:'shimmer 1.5s infinite' },

  /* ── Features Strip ── */
  featuresStrip:{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', borderTop:'1px solid var(--border)', borderBottom:'1px solid var(--border)' },
  featureItem:  { display:'flex', alignItems:'center', gap:'14px', padding:'22px 28px', borderRight:'1px solid var(--border)' },
  featureIcon:  { fontSize:'26px', flexShrink:0 },
  featureTitle: { fontFamily:'var(--font-display)', fontSize:'15px', letterSpacing:'1px', margin:'0 0 2px' },
  featureSub:   { fontSize:'12px', color:'#888', margin:0 },

  /* ── Story ── */
  story:        { background:'var(--black)', display:'grid', gridTemplateColumns:'1fr 1fr' },
  storyLeft:    { padding:'80px 56px', display:'flex', flexDirection:'column', justifyContent:'center' },
  storyKicker:  { fontFamily:'var(--font-script)', fontSize:'20px', color:'var(--gold)', marginBottom:'8px', margin:'0 0 8px' },
  storyTitle:   { fontFamily:'var(--font-display)', fontSize:'clamp(32px,4vw,52px)', letterSpacing:'2px', color:'#fff', lineHeight:1, marginBottom:'18px', margin:'0 0 18px' },
  storyBody:    { fontSize:'15px', color:'rgba(255,255,255,.5)', lineHeight:1.8, marginBottom:'28px', maxWidth:'400px', margin:'0 0 28px' },
  storyBtn:     { display:'inline-block', fontWeight:700, fontSize:'12px', letterSpacing:'2px', textTransform:'uppercase', color:'var(--gold)', borderBottom:'1px solid var(--gold)', paddingBottom:'3px', textDecoration:'none', marginBottom:'48px', alignSelf:'flex-start' },
  storyStats:   { display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:'0', borderTop:'1px solid rgba(255,255,255,.08)', paddingTop:'32px' },
  statItem:     { textAlign:'center' },
  statVal:      { fontFamily:'var(--font-display)', fontSize:'32px', color:'var(--gold)', letterSpacing:'2px', margin:'0 0 4px' },
  statLbl:      { fontSize:'11px', color:'rgba(255,255,255,.35)', letterSpacing:'1px', textTransform:'uppercase', margin:0 },
  storyRight:   { display:'flex', alignItems:'center', justifyContent:'center', position:'relative', overflow:'hidden', borderLeft:'1px solid rgba(255,255,255,.06)' },
  storyEmblem:  { width:'200px', height:'200px', border:'2px solid rgba(200,149,42,.3)', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', position:'relative', zIndex:2 },
  storyBgText:  { position:'absolute', fontFamily:'var(--font-display)', fontSize:'220px', color:'rgba(255,255,255,.02)', userSelect:'none', lineHeight:1 },

  /* ── Testimonials ── */
  testGrid:     { display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:'22px' },
  testCard:     { background:'#fff', padding:'28px', borderBottom:'3px solid var(--gold)', borderTop:'1px solid var(--border)' },
  testStars:    { color:'var(--gold)', fontSize:'16px', letterSpacing:'2px', marginBottom:'12px' },
  testText:     { fontSize:'14px', color:'#444', lineHeight:1.8, marginBottom:'18px', fontStyle:'italic' },
  testAuthor:   { display:'flex', alignItems:'center', gap:'12px', paddingTop:'14px', borderTop:'1px solid var(--border)' },
  testAvatar:   { width:'38px', height:'38px', borderRadius:'50%', background:'var(--black)', display:'flex', alignItems:'center', justifyContent:'center', fontFamily:'var(--font-display)', fontSize:'16px', color:'#fff', flexShrink:0 },

  /* ── Newsletter ── */
  newsletter:   { background:'var(--charcoal)', display:'grid', gridTemplateColumns:'1fr 1fr', gap:'40px', alignItems:'center', padding:'72px 64px', borderTop:'4px solid var(--red)' },
  nlLeft:       {},
  nlRight:      { display:'flex', flexDirection:'column' },
  nlInput:      { flex:1, border:'none', background:'rgba(255,255,255,.07)', color:'#fff', padding:'14px 18px', fontFamily:'var(--font-body)', fontSize:'14px', outline:'none', minWidth:0 },
  nlBtn:        { background:'var(--red)', color:'#fff', border:'none', padding:'14px 24px', fontFamily:'var(--font-body)', fontSize:'12px', fontWeight:700, letterSpacing:'2px', textTransform:'uppercase', cursor:'pointer', whiteSpace:'nowrap', flexShrink:0 },
};
